<ng-container [formGroup]="formGroup">
  <dsd-input
    identifier="courriel"
    formControlName="courriel"
    name="courriel"
    [required]="required"
    [minlength]="6"
    [maxlength]="maxLength"
    type="email"
    class="dsd-mb-md">
    <span slot="label">{{ 'caad.modifier-fiserv.courriel.adresseCourriel' | translate }}</span>
    <span slot="error" *ngIf="!formGroup.controls.courriel.value">{{
      'caad.modifier-fiserv.courriel.erreur.courrielVide' | translate
    }}</span>
    <span slot="error" *ngIf="formGroup.controls.courriel.value">{{
      'caad.modifier-fiserv.courriel.erreur.courrielInvalide' | translate
    }}</span>
  </dsd-input>
</ng-container>
